<template>
    <div class="select" :class="inputClass" v-click-outside="clickOutside">
        <div class="input" :class="{active:dropdown}" @click="dropdown = !dropdown">
            <input :value="value" readonly :placeholder="title">
        </div>
        <ul v-if="options && dropdown" class="dropdown-options">
            <li v-for="option in options"
                @click="value_id = option.id; dropdown = false"
                class="no-checkbox">
                {{ option.value }}
            </li>
        </ul>
    </div>
</template>

<script>
import ClickOutside from "./directives/ClickOutside";
export default {
    name: "SimpleSelect",
    directives: {
        'click-outside': ClickOutside
    },
    props: {
        title: {
            type: String,
            default: null
        },
        options: {
            type: Array,
            default: null
        },
        inputClass: null
    },
    data() {
        return {
            value_id: null,
            dropdown: false,
        }
    },
    watch: {
        value_id(value_id)
        {
            if (!value_id) {
                return
            }
            this.$emit('change', value_id)
        }
    },
    computed: {
        value() {
            for(let i in this.options) {
                if (this.value_id === this.options[i].id) {
                    return this.options[i].value
                }
            }
        }
    },
    methods: {
        clickOutside()
        {
            if (this.dropdown) {
                this.dropdown = false
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.dropdown-options {
    animation: dropdown-animation;
    animation-duration: 100ms;
    overflow: hidden;
}
@keyframes dropdown-animation {
    from {
        height: 0;
        line-height: 0;
    }
}
</style>
